define('evicommon/state/changes.helper',['require','exports','module','underscore','backbone'],function(require, exports, module){
  var _        = require('underscore');
  var Backbone = require('backbone');
  
  var UNSAVED_CHANGES = 'changes';

  function isNestedModelEqual(a, b) {
    return a.id == b.id;
  };

  function isNestedCollectionEqual(a, b) {
    if (a.length != b.length) { return false; }

    for (var i = 0; i < a.length; i++) {
      if (!isNestedModelEqual(a.at(i), b.at(i))) {
        return false;
      }
    };
    return true;
  };

  function isCollectionEqual(a, b) {
    if (a.length != b.length) { return false; }

    for (var i = 0; i < a.length; i++) {
      if (!isModelEqual(a.at(i), b.at(i))) {
        return false;
      }
    };
    return true;
  };

  function isModelEqual(a, b, numberOfLevelsToCheck) {
    if (a === b) { return true; }
    if (!(a instanceof Backbone.Model) || !(b instanceof Backbone.Model)) { return false; }
    var aKeys       = a.keys(),
        bKeys       = b.keys(),
        valueA      = null,
        valueB      = null,
        childModels = _.extend({}, a.childModels, b.childModels),
        allKeys     = null;

    if (aKeys.length !== bKeys.length) { return false; }

    allKeys = _.union(aKeys, bKeys);

    for (var i = 0, len = allKeys.length, key; i < len; i++) {
      key = allKeys[i];
      valueA = a.get(key);
      valueB = b.get(key);
      // we don't care about comparing nested child models
      //  ...unless we do
      // For the purpose of backwards compatibility function will default to ignoring changes to childModels.
      //  We can specify our level of caring about childModel changes by a positive number as numberOfLevelsToCheck
      if (!_.isEqual(valueA, valueB)) {
        if (childModels[key]) {

          if (!valueA || !valueB) {
            // if either value is falsey
            // then just return false
            return false;
          }
          if ((valueA instanceof Backbone.Model) && (valueB instanceof Backbone.Model)) {
            // Make sure that number of levels to check is a number and that it's positive
            //  so the loop will stop once the number of iterations >= numberOfLevelsToCheck.
            if (_.isNumber(numberOfLevelsToCheck) && numberOfLevelsToCheck > 0) {
              if (isModelEqual(valueA, valueB, numberOfLevelsToCheck - 1)) {
                continue;
              }
            } else if (isNestedModelEqual(valueA, valueB)) {
              continue;
            }
          } else if ((valueA instanceof Backbone.Collection) && (valueB instanceof Backbone.Collection)) {
            if (isNestedCollectionEqual(valueA, valueB)) {
              continue;
            }
          }

          // if we don't know what type they are
          // or the previous tests did not pass
          // then just return false
          return false;
        }
        // they are not equal and
        // they are not childModels
        // so just return false
        return false;
      }
    }
    return true;
  };

  var ChangesHelper = Backbone.Model.extend({

    initialize: function() {
      this.unsavedViewCount = 0;
      this.set(UNSAVED_CHANGES, false);
    },

    hasChanges: function() {
      return this.get(UNSAVED_CHANGES);
    },

    cloneResource: function(resource) {
      if (resource instanceof Backbone.Model) {
        return resource.clone();
      }
      else if (resource instanceof Backbone.Collection) {
        return new resource.constructor(
          _.map(resource.models, function(model) {
            return model.clone();
          })
        )
      }
    },

    add: function(model) {
      // Levels of nesting should be set as a parameter on the model. It represents how many layers
      //  of child models you have to go down to find all values that are will be dynamically changed.
      var unsaved  = false,
        levelsOfNesting = model.levelsOfNesting,
        original = this.cloneResource(model);


      function calculateChange() {
        var hasChanges = !this.isResourceEqual(original, model, levelsOfNesting);

        if (hasChanges && unsaved == false) {
          this.unsavedViewCount++;
        } else if (!hasChanges && unsaved == true) {
          this.unsavedViewCount = Math.max(0, this.unsavedViewCount-1);
        }
        unsaved = hasChanges;
        this._refreshState();
      };

      function reset() {
        original = this.cloneResource(model);
        calculateChange.call(this);
      };

      function clear() {
        original = null;
        calculateChange.call(this);
      };

      this
          .listenTo(model, 'change update', function(_model, options) {
            if (_.result(options, 'resetUnsavedChanges') === true) {
              reset.call(this);
              return;
            }
            calculateChange.call(this);
          })
          .listenTo(this, 'reset', reset)
          .listenTo(model, 'invalid', clear)
          .listenTo(model, 'sync', function(syncedModel) {
            // in case of collection, don't trigger reset when a
            // model inside collection syncs, only when collection itself syncs
            if(model == syncedModel) {
              reset.call(this);
            }
            else {
              var modelInsideOriginalCollection = original.get(syncedModel);
              var index = original.indexOf(modelInsideOriginalCollection);

              var clonedCopy = this.cloneResource(syncedModel);

              original.remove(modelInsideOriginalCollection);
              original.add(clonedCopy, {at: index});
              calculateChange.call(this);
            }
          })

      if (model.collection) {
        // model gets changes from collection which represents
        // the source of truth so if the collection emits a sync,
        // then we should reset the model
        this.listenTo(model.collection, 'sync', reset);
      }

      return this;
    },

    isResourceEqual: function(a, b, numberOfLevelsToCheck) {
      if ((a instanceof Backbone.Model) && (b instanceof Backbone.Model)) {
        return this.isModelEqual(a, b, numberOfLevelsToCheck);
      }
      else if ((a instanceof Backbone.Collection) && (b instanceof Backbone.Collection)) {
        return this.isCollectionEqual(a, b);
      }
      else {
        return false;
      }
    },

    isModelEqual: function(a, b, numberOfLevelsToCheck) {
      return isModelEqual(a, b, numberOfLevelsToCheck);
    },

    isCollectionEqual: function(a, b) {
      return isCollectionEqual(a, b);
    },

    remove: function(model) {
      this.stopListening(model);
      return this;
    },

    reset: function() {
      this.trigger('reset');
      return this;
    },

    _refreshState: function() {
      if (this.unsavedViewCount > 0) {
        this.set(UNSAVED_CHANGES, true);
      } else {
        this.set(UNSAVED_CHANGES, false);
      }
    }
  });

  ChangesHelper.UNSAVED_CHANGES = UNSAVED_CHANGES;
  ChangesHelper.isModelEqual = isModelEqual;

  module.exports = ChangesHelper;
});

